import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

import { MeteringPointsRoutingModule } from '@metering/metering-points-routing.module';
import { MeteringPointsGuard } from '@metering/guards/metering-point.guard';
import { MeteringPointsSelectedGuard } from '@metering/guards/metering-point-selected.guard';
import { MeteringPointsStoreModule } from '@appStore/metering-points';
import { TranslateModule } from '@ngx-translate/core';
import * as fromComponents from '@metering/components';
import * as fromContainers from '@metering/containers';

import { MaterialModule } from '@material';
import { CoreModule } from '@core/core.module';
import { SearchFilterDataService } from '@appStore/metering-points/search-filter-data-service';
import { MeteringGroupDialogComponent } from '@metering/components/metering-group-dialog/metering-group-dialog.component';
import { FunctionControlListingComponent } from '@metering/components/function-control-listing/function-control-listing.component';
import { MeteringPointItemPaneComponent } from '@metering/components/metering-point-item-pane/metering-point-item-pane.component';
// tslint:disable-next-line: max-line-length
import { MeteringPointFunctionControlPaneComponent } from '@metering/components/metering-point-function-control-pane/metering-point-function-control-pane.component';
import { MeteringPointLogicalPaneComponent } from '@metering/components/metering-point-logical-pane/metering-point-logical-pane.component';
import { MeteringPointMeteringPaneComponent } from '@metering/components/metering-point-metering-pane/metering-point-metering-pane.component';
import { DirectivesModule, RouterLinkDirective, SelectedTabDirective, AutoFocusDirective } from '@utils/directives';
import { PipesModule } from '@utils/pipes';

@NgModule({
  imports: [
    CoreModule,
    CommonModule,
    MeteringPointsStoreModule,
    MeteringPointsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    TranslateModule,
    DirectivesModule,
    PipesModule
  ],
  providers: [
    MeteringPointsGuard,
    MeteringPointsSelectedGuard,
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    SearchFilterDataService,
    RouterLinkDirective,
    SelectedTabDirective
  ],
  declarations: [
    ...fromContainers.containers,
    ...fromComponents.components,
    MeteringGroupDialogComponent,
    FunctionControlListingComponent,
    MeteringPointItemPaneComponent,
    MeteringPointFunctionControlPaneComponent,
    MeteringPointLogicalPaneComponent,
    MeteringPointMeteringPaneComponent
  ]
})
export class MeteringPointsModule {}
